<template>
  <div class="popper-wrapper">
    <popper
      v-if="popupText"
      :trigger="trigger"
      :options="options"
    >
      <div
        class="popper"
        :class="popperClasses"
      >
        <template v-if="popupText.title">
          <div class="popper__heading">
            {{ popupText.title }}
          </div>
        </template>
        <template v-if="popupText.content">
          <div class="popper__body">
            {{ popupText.content }}
          </div>
        </template>
        <template v-else>
          {{ popupText }}
        </template>
      </div>
      <template slot="reference">
        <slot name="reference" />
      </template>
    </popper>
    <slot
      v-else
      name="reference"
    />
  </div>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  name: 'TgPopper',

  components: {
    Popper,
  },

  props: {
    trigger: {
      type: String,
      default: 'hover',
    },
    popupText: {
      type: [String, Object],
      default: null,
    },
    options: {
      type: Object,
      default: () => ({
        placement: 'bottom',
        modifiers: {
          offset: { offset: '0,10px' },
        },
      }),
    },
  },

  computed: {
    popperClasses () {
      const classes = [];
      if (typeof this.popupText === 'object') {
        classes.push('popper--overlay');
      }

      return classes;
    },
  },
};
</script>

<style scoped>
  .popper {
    position: absolute;
    padding: .5rem 1rem;
    color: var(--border-color);
    background: #444;
    border-color: #444;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.15);
    max-width: 250px;
    box-sizing: border-box;
  }

  .popper[x-placement^="top"] {
    margin-bottom: 0;
  }
  .popper[x-placement^="top"] >>> .popper__arrow {
    border-width: 10px 10px 0 10px;
    border-color: #444 transparent transparent transparent;
    bottom: -10px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }
  .popper[x-placement^="bottom"] {
    margin-top: 0;
  }
  .popper[x-placement^="bottom"] >>> .popper__arrow {
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #444 transparent;
    top: -10px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }
  .popper[x-placement^="right"] {
    margin-left: 0;
  }
  .popper[x-placement^="right"] >>> .popper__arrow {
    border-width: 10px 10px 10px 0;
    border-color: transparent #444 transparent transparent;
    left: -10px;
    top: calc(50% - 10px);
    margin-left: 0;
    margin-right: 0;
  }
  .popper[x-placement^="left"] {
    margin-right: 0;
  }
  .popper[x-placement^="left"] >>> .popper__arrow {
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent #444;
    right: -10px;
    top: calc(50% - 10px);
    margin-left: 0;
    margin-right: 0;
  }
  .popper--overlay {
    color: inherit;
    padding: 0;
    border: 1px var(--border-color) solid;
    border-radius: 3px;
    background: #fff;
  }
  .popper--overlay[x-placement^="left"] >>> .popper__arrow {
    border-color: transparent transparent transparent var(--border-color);
  }
  .popper--overlay[x-placement^="top"] >>> .popper__arrow {
    border-color: var(--border-color) transparent transparent transparent;
  }
  .popper--overlay[x-placement^="right"] >>> .popper__arrow {
    border-color: transparent var(--border-color) transparent transparent;
  }
  .popper--overlay[x-placement^="bottom"] >>> .popper__arrow {
    border-color: transparent transparent var(--border-color) transparent;
  }
  .popper--overlay >>> .popper__arrow {
    color: #fff;
    border-top-color: var(--border-color);
    border-bottom-color: var(--border-color);
  }
  .popper__heading,
  .popper__body {
    text-align: left;
    font-size: .875rem;
    width: 100%;
    min-width: fit-content;
    padding: .5rem .75rem;
  }
  .popper__heading {
    font-weight: bold;
    background-color: var(--light-grey-bg);
    border-bottom: 1px var(--border-color) solid
  }
</style>
